<ng-scrollbar
  (clickOutside)="navMob()"
  [excludeBeforeClick]="true"
  [exclude]="'#mobile-collapse'"
  id="nav-ps-gradient-able"
  style="height: calc(100vh - 56px)"
>
  <div class="navbar-content">
    <ul
      class="nav pcoded-inner-navbar"
      (clickOutside)="fireOutClick()"
    >
      <ng-container *ngFor="let item of navigations">
        <app-nav-group
          *ngIf="item.type === 'group'"
          [item]="item"
        ></app-nav-group>
        <app-nav-collapse
          *ngIf="item.type === 'collapse'"
          [item]="item"
        ></app-nav-collapse>
        <app-nav-item
          *ngIf="item.type === 'item'"
          [item]="item"
        ></app-nav-item>
      </ng-container>
    </ul>
  </div>
</ng-scrollbar>
